import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';

// src/helpers/factories/menuModifierGroupFactory.ts
var menuModifierGroupsCardFactory = (modifierGroups) => Object.values(modifierGroups).map((modifierGroup) => {
  const itemCount = Object.keys(modifierGroup.itemIds).length;
  const modifierItemCount = modifierGroup.parentModifierItemIds.length;
  let tag = "";
  const tagStringArray = [];
  itemCount && tagStringArray.push(
    i18n_config_default.t("components.menuCard.tag.itemCount", { count: itemCount })
  );
  itemCount && modifierItemCount && tagStringArray.push(" | ");
  modifierItemCount && tagStringArray.push(
    i18n_config_default.t("components.menuCard.tag.modifierItemAbrevCountTag", {
      count: modifierItemCount
    })
  );
  tag = tagStringArray.join("");
  if (!tag)
    tag = i18n_config_default.t("commonTexts.noAssociations");
  return {
    id: modifierGroup.id,
    title: modifierGroup.name,
    itemCount,
    modifierItemCount,
    status: modifierGroup.active,
    activeFilter: modifierGroup.active ? 1 : 2,
    customTag: tag
  };
});

export { menuModifierGroupsCardFactory };
